import type {Config} from '@yandex-int/yandex-cfg';
import type {Environment} from '@yandex-taxi/frontend-common-server/src/consts';

import {nodeApi} from '../../utils/httpApi';

export type UserExperiments = Record<string, any>;

export type UserConfigs = Record<string, any>;

export type AppConfig = Pick<Config, 'environment'> & Config['frontend'] & {
    authproxyHost?: string;
    calltechHost?: string;
    calltechOrigins?: string[];
    passportHost?: string;
};

export type AppData = {
    appConfig: Partial<AppConfig>;
    user: {
        login: string;
    };
    experiments?: UserExperiments;
    configs?: UserConfigs;
    env: Environment;
};

export type GetConfigResponse = {
    version: string;
    appData: AppData;
};

class ConfigAPI {
    public getConfig() {
        return nodeApi.get<GetConfigResponse>('config');
    }
}

export const configApi = new ConfigAPI();
